export const useDocumentTitle=(newTitle)=>{
    document.title= `${newTitle} | Step Up Tutoring`
}